export const DAYS_PER_RANGE = 15;

const MONTH_LABELS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const formatAxisDateParts = (dateKey) => {
  if (!dateKey) return { monthDay: '', year: '' };
  const [y, m, d] = String(dateKey).split('-').map(Number);
  if (!y || !m || !d) return { monthDay: String(dateKey), year: '' };
  const monthDay = `${MONTH_LABELS[m - 1] || ''} ${String(d).padStart(2, '0')}`;
  return { monthDay, year: String(y) };
};

export const formatRangeLabel = (startDateKey, endDateKey) => {
  const start = formatAxisDateParts(startDateKey);
  const end = formatAxisDateParts(endDateKey);
  if (!start.monthDay) return '';
  if (startDateKey === endDateKey) return start.monthDay;
  return `${start.monthDay} to ${end.monthDay}`;
};

export const buildDateRanges = (days) => {
  if (!Array.isArray(days) || days.length === 0) return [];

  const ranges = [];
  for (let i = 0; i < days.length; i += DAYS_PER_RANGE) {
    const chunk = days.slice(i, i + DAYS_PER_RANGE);
    const startDate = chunk[0]?.date;
    const endDate = chunk[chunk.length - 1]?.date;
    if (!startDate || !endDate) continue;

    ranges.push({
      id: ranges.length,
      label: formatRangeLabel(startDate, endDate),
      startDate,
      endDate,
      startIndex: i,
      endIndex: i + chunk.length - 1,
    });
  }
  return ranges;
};
